<template>
  <div class="content-center">
    <!-- banner -->
    <img class="banner" id="book" :src="bannerLink" alt="" srcset="" />

    <!-- 战略事业版图 -->
    <section id="domain" class="domain_wrap">
      <img class="banner"  :src="careerMap.link" alt="" srcset="" />
      <div class="domain_title">战略事业版图</div>
    </section>

    <!-- 核心业务 -->
    <section id="business" class="business_wrap">
      <Business />
    </section>

    <section id="expand" class="total-width">
      <!-- 产教融合 -->
      <section class="fuse">
        <div class="pt-[80px] font-bold text-[40px]" id="fuse">产教融合</div>
        <div class="swiper">
          <swiper ref="mySwiper" :options="swiperOptionsFuse">
            <swiper-slide v-for="(item, index) in fuseArr" :key="index">
              <img :src="item.link" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <ul class="btm" v-for="(item, index) in fuseArr" :key="index">
          <div v-show="fushActiveTab === index" class="box">
            <li class="li">
              <h3>{{ item.title }}</h3>
              <p v-html="item.content"></p>
            </li>
          </div>
        </ul>
      </section>

      <!-- 校区展示 -->
      <section id="school" class="kk-school">
        <div class="pt-[80px] font-bold text-[40px]">校区展示</div>
        <swiper class="swiper" :options="swiperOptionsSchool">
          <swiper-slide v-for="(province, index) in school.provinces" :key="index">
            <img width="100%" :src="province.img" />
          </swiper-slide>
        </swiper>
      </section>
    </section>
  </div>
</template>

<script>
let vm = null;
import metaInfo from "@/common/util/metaInfo";
import Business from './components/Business.vue'
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { productsData } from "@/common/util/data";

export default {
  metaInfo: metaInfo.Products,
  components: { swiper, swiperSlide, Business },
  data() {
    return {
      ...productsData,
      swiperOptionsSchool: {
        loop: true,
        speed: 3000,
        spaceBetween: 10,
        slidesPerView: 2.3,
        loopedSlides: 5,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
        },
        observer: true,
        ovserveParents: true,
        on: {
          click: function () {
            vm.$router.push('/network')
          }
        }
      },
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination", //与slot="pagination"处 class 一致
          clickable: true, //轮播按钮支持点击
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
          renderBullet: function (index, className) {
            let text;
            switch (index) {
              case 0:
                text = "教辅类图书";
                break;
              case 1:
                text = "职业教育类图书";
                break;
              case 2:
                text = "考证类图书";
                break;
            }
            return '<span class="' + className + '" >' + text + "</span>";
          },
        },
        speed: 5000,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      },
      swiperOptionsFuse: {
        pagination: {
          el: ".swiper-pagination", //与slot="pagination"处 class 一致
          clickable: true, //轮播按钮支持点击
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
          renderBullet: function (index, className) {
            let text;
            switch (index) {
              case 0:
                text = "专业共建";
                break;
              case 1:
                text = "校企合作";
                break;
              case 2:
                text = "产业学院";
                break;
            }
            return '<span class="' + className + '" >' + text + "</span>";
          },
        },
        on: {
          click(event) {
            let fushActiveTab = Number(
              event.target.ariaLabel.split(" ")[3] - 1
            );
            console.log(fushActiveTab, vm);
            vm.tabChange(fushActiveTab);
          },
          slideChangeTransitionEnd: function () {
            this.activeIndex > 3 ? (this.activeIndex = 1) : "";
            let index = this.activeIndex - 1;
            vm.tabChange(index);
          },
        },
        speed: 2000,
        loop: true,
      },
      fushActiveTab: 0,
      eId: 1,
      oId: 1,
      educationTab: 0,
    };
  },
  created() {
    vm = this;
  },
  computed: {},
  mounted() {},
  methods: {
    tabChange(val) {
      this.fushActiveTab = val;
    },
  },
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
}
.domain_wrap {
  width: 100%;
  height: 100%;
  position: relative;
  .domain_title {
    font-size: 40px; 
    font-weight: 500;
    position: absolute;
    top: 74px;
    left: 11%;
    color: #111;
  }
}
.fuse {
  padding-bottom: 80px;
  .swiper {
    margin-top: 40px;
    width: 100%;
    .swiper-container {
      width: 100%;
      padding-top: 90px;
      .swiper-slide {
        width: 100%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
      }
      .swiper-pagination {
        text-align: left;
        ::v-deep {
          .my-bullet {
            text-align: center;
            cursor: pointer;
            display: inline-block;
            width: 160px;
            height: 50px;
            line-height: 50px;
            border-radius: 5px;
            font-size: 18px;
            font-weight: bold;
            background: #eaeaea;
          }
          .my-bullet:nth-child(2) {
            margin-left: 20px;
            margin-right: 20px;
          }
          .my-bullet-active {
            background: #cd3324;
            color: #fff;
            opacity: 1;
          }
        }
      }
    }
    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal > .swiper-pagination-bullets {
      top: 0px;
    }
    img {
      width: 100%;
    }
  }
  .btm {
    position: relative;
    z-index: 2;
    .li {
      padding-left: 40px;
      padding-right: 40px;
      width: 94%;
      height: 182px;
      background: linear-gradient(131deg, #e8624a 0%, #cd3324 100%) #cd3324;
      border-radius: 0px 40px 0px 0px;
      position: absolute;
      bottom: -80px;
      h3 {
        margin-top: 40px;
        margin-bottom: 15px;
        font-size: 32px;
        font-weight: bold;
        color: #ffffff;
        animation: myp 1s;
      }
      p {
        color: #ffffff;
        animation: myp 1s;
        line-height: 24px;
      }
      @keyframes myp {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      @keyframes fadeInRight {
        from {
          opacity: 0;
          -webkit-transform: translate(100%, 0);
          transform: stranslate(100%, 0);
        }
        to {
          opacity: 1;
          -webkit-transform: translate(0, 0);
          transform: stranslate(0, 0);
        }
      }
    }
  }
}
.kk-school {
  padding-bottom: 120px;
  background: #f3f4fb #ffffff;
  .swiper {
    margin-top: 40px;

    img {
      border-radius: 5px;
    }
  }
  :deep(.swiper-wrapper){
    transition-timing-function:linear !important;
   }
}

</style>
